import { Button } from '@/components/ui/button';
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon';
import ArrowRightIcon from '@/components/icons/ArrowRightIcon';

type DataTablePaginationProps<TData> = {
	range?: number;
	totalCount: number;
	page: number;
	setPage: (page: number) => void;
};

export function ETablePaginationWithApi<TData>({
	range = 2,
	totalCount,
	page: currentPage,
	setPage,
}: DataTablePaginationProps<TData>) {
	const getVisiblePages = (current: number, total: number, range: number) => {
		const pages: number[] = [];
		for (let i = 1; i <= total; i++) {
			if (
				i === 1 ||
				i === total ||
				(i >= current + 1 - range && i <= current + 1 + range)
			) {
				pages.push(i);
			}
		}
		return pages;
	};

	const addEllipses = (pages: number[]) => {
		const result: (number | '...')[] = [];
		for (let i = 0; i < pages.length; i++) {
			if (i > 0 && pages[i] !== pages[i - 1] + 1) {
				result.push('...');
			}
			result.push(pages[i]);
		}
		return result;
	};

	const visiblePages = getVisiblePages(currentPage, totalCount, range);
	const pagesWithEllipses = addEllipses(visiblePages);

	const handlePreviousPage = () => {
		setPage(currentPage - 1);
	};

	const handleNextPage = () => {
		setPage(currentPage + 1);
	};

	return (
		<div className='flex items-center justify-center gap-2'>
			<Button
				variant='outline'
				className={`h-fit max-h-11 max-w-11 p-3`}
				onClick={handlePreviousPage}
				disabled={currentPage <= 0}>
				<ArrowLeftIcon />
			</Button>
			{pagesWithEllipses.map((page, index) =>
				page === '...' ? (
					<Button
						key={index}
						variant='outline'
						className={`h-fit max-h-11 min-w-11 p-3`}>
						...
					</Button>
				) : (
					<Button
						key={index}
						variant={`${
							currentPage + 1 === page ? 'default' : 'outline'
						}`}
						className={`h-fit max-h-11 max-w-11 px-5 py-3`}
						onClick={() => setPage(page - 1)}>
						{page}
					</Button>
				),
			)}
			<Button
				variant='outline'
				className={`h-fit max-h-11 max-w-11 p-3`}
				onClick={handleNextPage}
				disabled={currentPage + 1 >= totalCount}>
				<ArrowRightIcon />
			</Button>
		</div>
	);
}
